import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **City Hotel Ljubljana System**
 *
 * @exports bs_307
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_307
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
       * @memberOf module:bs_307
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // https://www.cityhotel.si/booking/?checkin=2023-10-15&checkout=2023-10-20&guests=2&rooms=3&promo=THN3
        const url = new URL(ctx.baseUrl);
        const validUrl = !!url.pathname.match(/booking/) && !!url.hostname.match(/cityhotel/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        // adapt date format
        const dateBegin = ctx?.newData?.dateBegin?.replace(/\//g, '-');
        const dateEnd = ctx?.newData?.dateEnd?.replace(/\//g, '-');
        // set params
        url.searchParams.set('checkin', dateBegin);
        url.searchParams.set('checkout', dateEnd);
        url.searchParams.set('guests', '[adults]');
        url.searchParams.set('rooms', '[rooms]');
        // remove /step/2
        ctx.newUrl = url.toString()?.replace(/\/step\/2\//, '/');
        return ctx;
    };
    /**
      *
      * @memberOf module:bs_307
      *
      */
    function roomDetailsParseData() {
        const roomElArray = [...document.querySelectorAll('.services.dt')];
        if (thn.empty(roomElArray)) {
            return {};
        }
        const roomsInfo = roomElArray
            .map((room) => {
            const roomName = room.querySelector('.dtc h6')?.innerText;
            const roomType = getRoomType(roomName);
            const guests = room.querySelectorAll('.dtc:nth-child(2)>.dt>.dtr:not(.h100):nth-child(1) .dtc>.fa-user')?.length;
            const roomRates = [...room.querySelectorAll('.dtc:nth-child(2)>.dt>.dtr:not(.h100)')]
                .map((rate) => {
                const rateName = '';
                const price = thn.parseNumber(rate.querySelector('.price>input')?.value);
                const hasBreakfast = !!rate.querySelector('.dtc:nth-child(3)>.pr:nth-child(1)')?.textContent?.match(/breakfast|colazione|frühstücksbuffet|zajtrkom/i);
                const isRefundable = !!rate.querySelector('.dtc:nth-child(3)>.pr:nth-child(2)')?.textContent?.match(/cancellazione gratuita|free cancellation|kostenlose absage|brezplačna odpoved/i);
                const infoRate = {
                    id: '',
                    name: rateName,
                    totalNight: price,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return infoRate;
            });
            return {
                id: '',
                name: roomName,
                adults: guests || 2,
                children: 0,
                type: roomType,
                prices: roomRates,
            };
        }).filter(Boolean);
        return roomsInfo;
    }
    /**
      * @memberOf module:bs_307
      * @this thn.widgets.price
      * @see {@link Price#set_data}
      *
      * @param {object} ctx - The context object.
      */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        let nights;
        const dateBegin = document.querySelector('.summary>.summaryStep1>div:nth-child(2)>div:nth-child(2)')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        const dateEnd = document.querySelector('.summary>.summaryStep1>div:nth-child(3)>div:nth-child(2)')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Room info
        const inputGuest = thn.parseNumber(document.querySelector('.summary>.summaryStep1>div:nth-child(5)>div:nth-child(2)')?.textContent) || 2;
        const roomInfo = [...document.querySelectorAll('.services.dt>.dtr>.dtc:nth-child(2)>.dt>.dtr:not(.h100)')].map((room) => ({
            price: thn.parseNumber(room.querySelector('.price input')?.value),
            currency: thn.parseCurrency(room.querySelector('.price')?.textContent),
            guests: room.querySelectorAll('.dtr>.dtc:nth-child(2)>.dt>.dtr>.dtc>.dt>.dtr>.dtc:nth-child(1)>.fa-user:not(.paxExtra)').length,
        })).sort((a, b) => a.price - b.price).filter((room) => room.guests === inputGuest);
        // Guests, Adults & Children
        const adults = !thn.empty(roomInfo) ? roomInfo[0]?.guests : inputGuest || 2;
        const price = roomInfo[0]?.price;
        widgetData.adults = adults;
        widgetData.children = 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // Prices & Currency || No Rooms
        if (!thn.empty(roomInfo) && nights && !thn.empty(price) && typeof price === 'number') {
            widgetData.price = price / nights;
            widgetData.currency = roomInfo[0]?.currency;
            widgetData.roomDetails = roomDetailsParseData();
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_307
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.dataLayer || [];
        const bookingId = thn.objectGet(dataLayer, 'transaction_id', { first: false });
        if (!bookingId) {
            return widgetData;
        }
        // Booking ID
        widgetData.bookingId = bookingId;
        // Dates
        const dateBegin = document.querySelector('.summaryStep1>.oh:nth-child(1)>div:nth-child(2)')?.textContent;
        const dateEnd = document.querySelector('.summaryStep1>.oh:nth-child(2)>div:nth-child(2)')?.textContent;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        }
        // price & currency
        const price = thn.objectGet(dataLayer, 'value', { first: false });
        const currency = thn.objectGet(dataLayer, 'currency', { first: false });
        widgetData.price = price;
        widgetData.currency = currency;
        widgetData.promocode = thn.widgets.price.getPromocode().promocode;
        return widgetData;
    };
    /**
       * @memberOf module:bs_307
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = document.querySelector('[id*="Promo"] .strong:nth-child(2)')?.textContent?.split(' ')?.[0];
        if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
